export default "__VITE_ASSET__Y$cZhmA___";